import React, { Component } from "react";
import {
  Card,
  RaisedButton,
  FloatingActionButton,
  FlatButton,
  Subheader,
  Divider,
  CardTitle,
} from "material-ui";
import formatDate from "../../../utils/formatDate";
import ContentAdd from "material-ui/svg-icons/content/add";
import FilterIndex from "../FilterIndex";
import Loading from "../Loading";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

export default class TemplateIndex extends Component {
  constructor(props) {
    super(props);

    this.renderTable = this.renderTable.bind(this);
    this.viewButton = this.viewButton.bind(this);
  }

  viewButton(cell, row) {
    let url = `/job/communicationsManager/documentTemplates/${cell}`;
    return (
      <FlatButton
        label="View"
        backgroundColor="#E0E0E0"
        hoverColor="#BDBDBD"
        onClick={this.props.performRoute.bind(this, url)}
      />
    );
  }

  renderTable() {
    if (this.props.isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={this.props.appbar.color} />
          </center>
        </div>
      );
    } else {
      let filter = { type: "TextFilter", delay: 500 };
      return (
        <div>
          <BootstrapTable data={this.props.workOrders} pagination>
            <TableHeaderColumn
              dataField="createdAt"
              dataSort
              filter={filter}
              dataFormat={(d) => formatDate(new Date(d))}
            >
              Created
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="name"
              dataSort
              filter={filter}
              isKey
              width="200"
              dataFormat={this.linkFormatter}
            >
              Name
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="updatedAt"
              dataSort
              filter={filter}
              dataFormat={(d) => formatDate(new Date(d))}
            >
              Updated
            </TableHeaderColumn>
            <TableHeaderColumn dataField="type" dataSort filter={filter}>
              Type
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="_id"
              dataFormat={this.viewButton}
              width="100"
            ></TableHeaderColumn>
          </BootstrapTable>
        </div>
      );
    }
  }

  render() {
    return (
      <Card
        className="container"
        zDepth={2}
        style={{ marginTop: "2em", padding: "2em 7em 0em 7em" }}
      >
        <CardTitle title="Templates" />
        <FlatButton
          label="New Template"
          onClick={this.props.performRoute.bind(
            this,
            "/job/communicationsManager/documentTemplates/new",
          )}
          style={{ marginBottom: "1em" }}
        />
        <Divider style={{ margin: "1em 1em" }} />
        <FilterIndex
          url="templates/getTemplates"
          filterKey="type"
          {...this.props}
        />
        <br />
        {this.renderTable()}
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/document_templates/TemplateIndex.js